import React, { ReactNode } from 'react';

import './showcase-lesson-teaser-card__content.scss';

interface Props {
    children?: ReactNode;
}

export const ShowcaseLessonTeaserCardContent = ({ children }: Props) => (
    <div className="showcase-lesson-teaser-card__content">{children}</div>
);
